var u=(n,e)=>!n||n.length<=e?n??null:`${n.slice(0,e-3)}...`;export{u as a};
